import { render, staticRenderFns } from "./futures.vue?vue&type=template&id=773b6b20&"
import script from "./futures.vue?vue&type=script&lang=js&"
export * from "./futures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports